import { render, staticRenderFns } from "./AppWebcam.vue?vue&type=template&id=68d066f8&scoped=true&"
import script from "./AppWebcam.vue?vue&type=script&lang=js&"
export * from "./AppWebcam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d066f8",
  null
  
)

export default component.exports